<template>
  <div class="row mt-6">
    <div v-if="notice" class="callout notice">{{notice}}</div>
    <div class="flex justify-center relative text-center mb-16">
        <div class="absolute left-0 top-4 flex items-center justify-center text-blue text-2xl cursor-pointer" @click="clickedBack">
          <fai :icon="['fas', 'chevron-left']" />
          <p class="ml-2 mb-0">back</p>
        </div>
        <p class="mb-3 text-blue text-6xl font-black font-['AileronThin']">$pringpay</p>
    </div>
    <div v-if="isProgramLoading" class="flex justify-center items-center p-4">
      <sb-loading-icon />
    </div>
    <div v-else class="medium-6 columns small-centered">
      <div class="cash_per_point_enabled-wrapper">
        <label class="text-center mb-4">enter your spence api token</label>
        <div class="relative h-full">
          <input
            :type="showApiKey ? 'text' : 'password'"
            data-cy="spence-landing-spence-api-key-input"
            v-model="apiKey"
            :disabled="!canEditSettings"
            :class="{ error: error }"
          />
          <span
            v-if="apiKey"
            :class="['absolute right-3 top-2 cursor-pointer text-blue', { error: error }]"
            @click="showApiKey = !showApiKey">
              {{ showApiKey ? 'hide' : 'show' }}
          </span>
        </div>
        <div  class="text-center error mb-6">
          {{ error }}
        </div>
      </div>
      <div class="sb-row space-evenly bottom-spacing">
        <button @click.stop.prevent="clickedCancel" :disabled="submitting" class="link-delete">cancel</button>
        <button @click="clickedSubmit" :disabled="submitting" class="action-button button proceed">update</button>
      </div>
      <div class="sb-row center">
        <a href="https://gospence.com/contact-us/" target="_blank">new to spence?</a>
      </div>
    </div>
  </div>
</template>

<script>
  import UserAbilitiesMixin from '../../mixins/UserAbilitiesMixin'
  import { currentMerchantAPI } from '../../services/api/currentMerchant'
  import { mapGetters } from 'vuex'
  import spenceLogo from 'spence/spence_logo.svg'

    export default {
      name: "SpenceLanding",
      data() {
        return {
          apiKey: "",
          showApiKey: false,
          spenceLogo: spenceLogo,
          isProgramLoading: false,
          showSpringpay: false,
          submitting: false,
          notice: "",
          error: "",
        }
      },
      mixins: [UserAbilitiesMixin],
      computed: {
        merchantId() {
          return this.$route.params.id
        },
        canEditSettings() {
          return this.hasAccess(this.userAbilitiesValue, 'SETTINGS_EDIT')
        },
        withEditParam() {
          return this.$route.query.editing
        },
        ...mapGetters(
          ['userAbilitiesValue']
        )
      },
      watch: {
        apiKey(newValue) {
          this.error = ""
        }
      },
      async created() {
        this.$store.dispatch('LOAD_CURRENT_USER')
        this.$store.dispatch('LOAD_CURRENT_MERCHANT')
        this.isProgramLoading = true
        try {
          const { show_springpay, spence_api_key } = await currentMerchantAPI.GETCashPerPointsSettings('spence_api_key')
          this.showSpringpay = show_springpay
          if (this.showSpringpay) {
            this.apiKey = spence_api_key || ""
            if (this.apiKey?.length && !this.withEditParam) {
              this.goToCashRewardsProgramPage()
            }
          } else {
            location.replace(`/merchants/${this.merchantId}/`)
          }
        } catch (error) {
          this.error = 'error, please refresh or contact support'
        } finally {
          this.isProgramLoading = false
        }
      },
      methods: {
        async clickedSubmit() {
          if (this.apiKey.length < 20) {
            this.error = 'Token length must be at least 20'
            return
          }

          const body = { api_key: this.apiKey }

          this.submitting = true
          try {
            const result = await currentMerchantAPI.PATCHSpenceApiKey(this.merchantId, body)
            if (result) {
              this.goToCashRewardsProgramPage()
            } else {
              this.error = 'The api key entered was invalid. Please check it and try again.'
            }
          } catch (error) {
            this.error = 'The api key entered was invalid. Please check it and try again.'
          } finally {
            this.submitting = false
          }
        },
        clickedBack() {
          this.$router.push(`/merchants/${this.merchantId}/springpay_landing`)
        },
        clickedCancel() {
          this.$router.back()
        },
        goToCashRewardsProgramPage() {
          this.$router.push(`/merchants/${this.merchantId}/cash_rewards_program?type=spence`)
        }
      }
    }
</script>

<style scoped>
input.error {
  border: 1px solid red;
}

.sb-row {
  justify-content: unset;
}
</style>
